import { FetchDriver, Logout, SetDriver } from 'src/constants/actionTypes'
import { Action } from 'src/utils/reduxUtils'
import { DriverState } from './types'
import { Driver } from 'src/interfaces/driver'

const SESSION_STORAGE_KEY = 'cachedDriver'

const readCachedDriver = (): Driver | null => {
  try {
    const raw = sessionStorage.getItem(SESSION_STORAGE_KEY)

    return raw ? (JSON.parse(raw) as Driver) : null
  } catch {
    return null
  }
}

export const writeCachedDriver = (driver: Driver | null) => {
  try {
    if (driver) {
      sessionStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(driver))
    } else {
      sessionStorage.removeItem(SESSION_STORAGE_KEY)
    }
  } catch {
    // ignore
  }
}

const getInitialState = (): DriverState => ({
  driver: readCachedDriver(),
  driverFetchFailed: false,
})

export const driverReducer = (
  state: DriverState = getInitialState(),
  action: Action<any>,
): DriverState => {
  switch (action.type) {
    case FetchDriver.type.REQUEST:
      return {
        ...state,
        driverFetchFailed: false,
      }
    case FetchDriver.type.FAILED:
      return {
        ...state,
        driverFetchFailed: true,
      }
    case SetDriver.type.SUCCESS:
      return {
        ...state,
        driver: action.payload,
        driverFetchFailed: false,
      }
    case Logout.type.SUCCESS:
      return getInitialState()
    default:
      return state
  }
}
